import { useSearchParams } from "react-router-dom";
import { useFetch } from "../../../hooks/Fetching";
import dayjs from "dayjs";
import useUser from "../../../hooks/useUser";

export default function useGetHomePageAdminAppointments() {
  const [searchParams] = useSearchParams();
  const { profile } = useUser();
  var date = searchParams.get("date") ?? "";
  var view = searchParams.get("view") ?? "";
  if (String(date) === "Invalid Date") {
    date = "";
  }

  const apiPath = `/appointments/clinic/homepage/?date=${date}&view=${view}`;
  const { data, isLoading, error } = useFetch(apiPath, null, [
    "CLINIC_HOMEPAGE_KEY",
    date,
    view,
    profile.id,
  ]);
  return { data, isLoading, error };
}

export function useGetHomePageAdminAppointmentsMonth() {
  const [searchParams] = useSearchParams();
  const { profile } = useUser();

  var date = searchParams.get("date") ?? "";
  var dateKey = null;
  if (String(date) === "Invalid Date") {
    date = "";
  } else {
    const year = String(searchParams.get("date")).split("/")[2];
    const month = String(searchParams.get("date")).split("/")[1];
    dateKey = month + "/" + year;
  }

  const apiPath = `/appointments/clinic/homepage/month_calendar/?date=${date}`;
  const { data, isLoading, error } = useFetch(apiPath, null, [
    "CLINIC_HOMEPAGE_KEY",
    dateKey,
    profile.id,
  ]);
  return { data, isLoading, error };
}
